import { ruleRunner } from 'validations/ruleRunner';
import { required } from 'validations/rules';

const Validations = [ruleRunner('description', 'descrição', required)];

export default Validations;
